import { render, staticRenderFns } from "./delete-procedure-template.vue?vue&type=template&id=7e106d10&scoped=true&"
import script from "./delete-procedure-template.vue?vue&type=script&lang=js&"
export * from "./delete-procedure-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e106d10",
  null
  
)

export default component.exports